import _MoreHorizontalIcon from "@adsk/alloy-react-icon/es/lib/MoreHorizontalIcon";
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import Avatar from './Avatar';
import { AVATAR_SIZES, AVATAR_GROUP_TRUNCATION, AVATAR_GROUP_MORE_ICON_SIZE } from './constants';
const Truncation = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    style,
    className,
    truncation,
    size,
    count,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement(Avatar, {
    ref: ref,
    onClick: onClick,
    className: className,
    size: size,
    style: [{
      cursor: 'pointer',
      color: theme.tokens.colors.text.primary.value,
      backgroundColor: theme.tokens.colors.background.accent.six.subtler.value,
      ':hover': {
        color: theme.tokens.colors.icon.primary.value,
        backgroundColor: theme.tokens.colors.background.hover.value
      }
    }, style]
  }, truncation === AVATAR_GROUP_TRUNCATION.NUMERIC && `+${count}`, truncation === AVATAR_GROUP_TRUNCATION.DOTTED && /*#__PURE__*/React.createElement(_MoreHorizontalIcon, {
    size: AVATAR_GROUP_MORE_ICON_SIZE[size]
  }));
});
Truncation.displayName = 'Truncation';
Truncation.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** count displayed for numeric truncation */
  count: PropTypes.number.isRequired,
  /** Set the size of the avatar */
  size: PropTypes.oneOf(Object.values(AVATAR_SIZES)).isRequired,
  /** Set the size of the avatar */
  truncation: PropTypes.oneOf(Object.values(AVATAR_GROUP_TRUNCATION)),
  /** Class applied to the root element */
  onClick: PropTypes.func
};
export default Truncation;
//# sourceMappingURL=Truncation.js.map